import type { LocalizedText } from "../../api/CertRoadmap/types";
import { localizedText } from "./localizedText";
import type { RoadmapLanguage } from "./types";

type BilingualTextProps = {
  value?: LocalizedText | string | null;
  language: RoadmapLanguage;
};

const BilingualText = ({ value, language }: BilingualTextProps) => {
  const text = localizedText(value, language);
  if (!text) return null;

  return (
    <span lang={language} dir={language === "ar" ? "rtl" : "ltr"}>
      {text}
    </span>
  );
};

export default BilingualText;
